import React from 'react';
import CommitActivityChart from './CommitActivityChart';

const Homepage = ({ onNavigateToTab }) => {
  return (
    <div className="hp">
      {/* Hero */}
      <section className="hp-hero">
        <span className="hp-eyebrow">Microsoft documentation, tracked</span>
        <h1 className="hp-title">
          Stay ahead of <span className="hp-title-accent">Microsoft cloud</span> changes
        </h1>
        <p className="hp-lead">
          A continuously updated view of what's changing across Microsoft's official
          documentation, with AI-generated summaries so you can skip the noise and read
          only what matters.
        </p>
        <div className="hp-cta-row">
          <button className="hp-btn hp-btn-primary" onClick={() => onNavigateToTab('entra')}>
            Browse changes
          </button>
        </div>
      </section>

      {/* Have you seen? */}
      <section className="hp-seen">
        <div className="hp-seen-label">
          <span className="hp-seen-icon">✦</span>
          Have you seen?
        </div>
        <div className="hp-seen-cards">
          <a href="https://msmessagecenter.com" target="_blank" rel="noopener noreferrer" className="hp-seen-card">
            <div className="hp-seen-card-icon">📬</div>
            <div>
              <div className="hp-seen-card-title">MSMessageCenter.com</div>
              <div className="hp-seen-card-desc">Browse and search the Microsoft 365 Message Center without needing admin access.</div>
            </div>
          </a>
          <a href="https://msicons.com" target="_blank" rel="noopener noreferrer" className="hp-seen-card">
            <div className="hp-seen-card-icon">🎨</div>
            <div>
              <div className="hp-seen-card-title">MSIcons.com</div>
              <div className="hp-seen-card-desc">The largest library of Microsoft product icons, free to download and use.</div>
            </div>
          </a>
        </div>
      </section>

      {/* Stats */}
      <section className="hp-stats">
        <div className="hp-stats-head">
          <div>
            <p className="hp-card-sub">Documentation changes tracked over the last 7 days</p>
          </div>
        </div>
        <CommitActivityChart />
      </section>

      {/* Content */}
      <section className="hp-info-grid">
        <article className="hp-info">
          <h3 className="hp-info-title">The challenge</h3>
          <p>
            Microsoft maintains vast documentation repositories that change daily — new
            features, security updates, deprecations and best practices. Manually monitoring
            everything relevant to your work is nearly impossible, and RSS feeds or email
            subscriptions tend to bury the signal in noise.
          </p>
        </article>
        <article className="hp-info">
          <h3 className="hp-info-title">The solution</h3>
          <p>
            This tracker watches Microsoft's official GitHub documentation repositories and
            produces concise, AI-generated summaries of each change. Pick a source from the
            navigation above to see the last 7 days of meaningful updates at a glance.
          </p>
        </article>
      </section>

      <p className="hp-signoff">
        Built by <a href="https://www.linkedin.com/in/danielbradley2/">Daniel Bradley</a>
      </p>
    </div>
  );
};

export default Homepage;